import { alpha } from '@mui/system';
import { CustomerNameBackground } from '../../../assets';
import { themeObject as theme } from '../../../lib';

export const acceptableUsePolicyStyles = {
    mainContainerStyles: {
        backgroundImage: `url(${CustomerNameBackground})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundPosition: 'top',
        overflow: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        py: '70px',
    },
    containerStyles: {
        width: '725px',
        borderRadius: '20px',
        padding: '47px 55px 28px 53px',
        boxShadow: `0px 1px 18px 0px ${alpha(
            theme.palette.grayScale[700],
            0.12
        )},0px 6px 10px 0px ${alpha(
            theme.palette.grayScale[700],
            0.14
        )},0px 3px 5px -1px ${alpha(theme.palette.grayScale[700], 0.2)}`,
        backgroundColor: theme.palette.background.default,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    imageStyles: {
        height: '74px',
        width: '176px',
    },
    headingContainer: {
        my: 4,
    },
    headingStyles: {
        fontFamily: 'Raleway',
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '100%',
        color: theme.palette.primary[700],
    },
    contentContainer: {
        maxHeight: '639px',
        height: '100%',
        overflowY: 'auto',
    },
    contentStyles: {
        fontFamily: 'DM Sans',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '100%',
        color: theme.palette.grayScale[800],
        textAlign: 'left',
        ol: {
            display: 'flex',
            flexDirection: 'column',
            rowGap: '16px',
            '& li': {
                '& ol': {
                    mt: 2,
                },
            },
        },
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '15px',
        mt: '36px',
    },
    buttonStyles: {
        width: '340px',
    },
};
